export default __webpack_public_path__ + "img/share.a7db1fa3.svg";